import type { ExperienceListFilters } from 'actions/ExperienceActions'
import { fetchExperienceList, fetchExperienceTimes } from 'actions/ExperienceActions'
import getLoyaltyLoungePassItems from 'checkout/selectors/view/items/getLoyaltyLoungePassItems'
import useExperiences from 'hooks/Experiences/useExperiences'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { unique } from 'lib/array/arrayUtils'
import useLoyaltyConfig from 'loyalty/hooks/useLoyaltyConfig'
import { useEffect, useMemo } from 'react'
import { isCheckoutReviewAndPaymentStepId } from 'checkout/constants/pages'

interface Options {
  filters: Array<ExperienceListFilters>
  currentStepId?: string
}

function useLoyaltyLoungePassData({ filters, currentStepId }: Options) {
  const items = useAppSelector(state => getLoyaltyLoungePassItems(state))

  const dispatch = useAppDispatch()
  // populate the config object, we use it to decide if we can show the section
  useLoyaltyConfig()
  const experienceIds = useMemo(() => unique(items.map(item => item.experienceId)), [items])
  // make sure all experiences we're using are fetched
  useExperiences(experienceIds)

  useEffect(() => {
    items.forEach(item => {
      // get the data for the timeslot currently selected, this gets us our ticket data
      dispatch(fetchExperienceTimes(item.experienceId, {
        date: item.isBookLater ? undefined : item.date,
        isBuyNowBookLater: item.isBookLater,
        redemptionLocationId: item.redemptionLocation,
      }))
    })
  }, [dispatch, items])

  // fetch the lounges to display in the modal
  useEffect(() => {
    if (!currentStepId || isCheckoutReviewAndPaymentStepId(currentStepId)) {
      filters.forEach(filters => {
        dispatch(fetchExperienceList(filters))
      })
    }
  }, [dispatch, filters, currentStepId])
}

export default useLoyaltyLoungePassData
